import Vue from 'vue'
import Router from 'vue-router'
import index from 'components/index.vue'
import login from 'components/login.vue'
import ask from 'components/ask.vue'
import expertDetail from 'components/expertDetail.vue'
import agreement from 'components/agreement.vue'
import selectTime from 'components/selectTime.vue'
import serveInfo from 'components/serveInfo.vue'
import appraiseList from 'components/appraiseList.vue'
import music from 'components/music.vue'
import my from 'components/my.vue'
import feedback from 'components/feedback.vue'
import consult from 'components/consult.vue'
import evaluate from 'components/evaluate.vue'
import courseList from 'components/courseList.vue'
import courseDetail from 'components/courseDetail.vue'
import artHealing from 'components/artHealing.vue'
import activityCenter from 'components/activityCenter.vue'
import articleList from 'components/articleList.vue'
import articleDetail from 'components/articleDetail.vue'
import myCourse from 'components/myCourse.vue'
import myCollection from 'components/myCollection.vue'
import test from 'components/test.vue'
import testList from 'components/testList.vue'
import testDetail from 'components/testDetail.vue'
import topic from 'components/topic.vue'
import result from 'components/result.vue'
import myTest from 'components/myTest.vue'
import changePhone from 'components/changePhone.vue'
import news from 'components/news.vue'
import reply from 'components/reply.vue'
import serviceAssistant from 'components/serviceAssistant.vue'
import serviceAssistantDetail from 'components/serviceAssistantDetail.vue'
import mentalExperience from 'components/mentalExperience.vue'
import correct from 'components/correct.vue'
import testResult from 'components/testResult.vue'
import correctResult from 'components/correctResult.vue'
import activityDetail from 'components/activityDetail.vue'
import pay from 'components/pay.vue'
import eBook from 'components/eBook.vue'
import information from 'components/information.vue'
import informationDetail from 'components/informationDetail.vue'
import informationWord from 'components/informationWord.vue'
import help from 'components/help.vue'
import pcData from 'components/pcData.vue'
import pcData1 from 'components/pcData1.vue'
import pcData2 from 'components/pcData2.vue'
import video from 'components/video.vue'
import jokeDetail from 'components/jokeDetail.vue'
import eBookDetail from 'components/eBookDetail.vue'
import eBookWord from 'components/eBookWord.vue'
import myEBook from 'components/myEBook.vue'


Vue.use(Router)


export default new Router({
    // mode:"history",
    mode:"hash",
    base:'/student',
    scrollBehavior(to,from,savedPosition){
        return {x:0,y:0}
    },
    routes: [
        {
            path: '/',
            name: 'index',
            component: index,
            meta: {
                keepAlive: false // 需要缓存
            }
        },
        
        {
            path: '/jokeDetail',
            name: 'jokeDetail',
            component: jokeDetail,
        },
        
        {
            path: '/myEBook',
            name: 'myEBook',
            component: myEBook,
        },
        
        {
            path: '/eBookWord',
            name: 'eBookWord',
            component: eBookWord,
        },
        
        {
            path: '/eBookDetail',
            name: 'eBookDetail',
            component: eBookDetail,
        },
        

        {
            path: '/information',
            name: 'information',
            component: information,
        },

        {
            path: '/video',
            name: 'video',
            component: video,
        },

        {
            path: '/pcData',
            name: 'pcData',
            component: pcData,
        },

        {
            path: '/pcData1',
            name: 'pcData1',
            component: pcData1,
        },

        {
            path: '/pcData2',
            name: 'pcData2',
            component: pcData2,
        },

        {
            path: '/informationDetail',
            name: 'informationDetail',
            component: informationDetail,
        },

        {
            path: '/informationWord',
            name: 'informationWord',
            component: informationWord,
        },

        {
            path: '/login',
            name: 'login',
            component: login,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/ask',
            name: 'ask',
            component: ask,
            meta: {
                keepAlive: true // 需要缓存
            }
        },

        {
            path: '/expertDetail',
            name: 'expertDetail',
            component: expertDetail,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/agreement',
            name: 'agreement',
            component: agreement,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/selectTime',
            name: 'selectTime',
            component: selectTime,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/serveInfo',
            name: 'serveInfo',
            component: serveInfo,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/appraiseList',
            name: 'appraiseList',
            component: appraiseList,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/music',
            name: 'music',
            component: music,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/my',
            name: 'my',
            component: my,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/feedback',
            name: 'feedback',
            component: feedback,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/consult',
            name: 'consult',
            component: consult,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/evaluate',
            name: 'evaluate',
            component: evaluate,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/courseList',
            name: 'courseList',
            component: courseList,
            meta: {
                keepAlive: true // 不需要缓存
            }
        },

        {
            path: '/courseDetail',
            name: 'courseDetail',
            component: courseDetail,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/artHealing',
            name: 'artHealing',
            component: artHealing,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/activityCenter',
            name: 'activityCenter',
            component: activityCenter,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/articleList',
            name: 'articleList',
            component: articleList,
            meta: {
                keepAlive: true // 需要缓存
            }
        },

        {
            path: '/articleDetail',
            name: 'articleDetail',
            component: articleDetail,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/myCourse',
            name: 'myCourse',
            component: myCourse,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/myCollection',
            name: 'myCollection',
            component: myCollection,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/test',
            name: 'test',
            component: test,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/testList',
            name: 'testList',
            component: testList,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/testDetail',
            name: 'testDetail',
            component: testDetail,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/topic',
            name: 'topic',
            component: topic,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/result',
            name: 'result',
            component: result,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/myTest',
            name: 'myTest',
            component: myTest,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/changePhone',
            name: 'changePhone',
            component: changePhone,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/news',
            name: 'news',
            component: news,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },

        {
            path: '/reply',
            name: 'reply',
            component: reply,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },
        {
            path: '/serviceAssistant',
            name: 'serviceAssistant',
            component: serviceAssistant,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },
        {
            path: '/serviceAssistantDetail',
            name: 'serviceAssistantDetail',
            component: serviceAssistantDetail,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },
        {
            path: '/mentalExperience',
            name: 'mentalExperience',
            component: mentalExperience,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },
        {
            path: '/correct',
            name: 'correct',
            component: correct,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },
        {
            path: '/testResult',
            name: 'testResult',
            component: testResult,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },
        {
            path: '/correctResult',
            name: 'correctResult',
            component: correctResult,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },
        {
            path: '/help',
            name: 'help',
            component: help,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },
        {
            path: '/activityDetail',
            name: 'activityDetail',
            component: activityDetail,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },
        {
            path: '/pay',
            name: 'pay',
            component: pay,
            meta: {
                keepAlive: false // 不需要缓存
            }
        },
        {
            path: '/eBook',
            name: 'eBook',
            component: eBook,
            meta: {
                keepAlive: false // 不需要缓存
            }
        }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js